import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4">
      <div className="text-center">
        <p className="text-7xl md:text-9xl font-black text-foreground-100 select-none">
          404
        </p>
        <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mt-2">
          Page Not Found
        </h1>
        <p className="mt-3 text-foreground-600 max-w-md mx-auto">
          The page you are looking for does not exist or may have been moved.
        </p>
        <p className="mt-1 text-sm text-foreground-400 font-mono">
          {location.pathname}
        </p>
        <div className="mt-8">
          <a
            href="/"
            className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-white font-medium rounded-lg hover:bg-primary-600 transition-colors"
          >
            <i className="ri-home-4-line" />
            Back to Home
          </a>
        </div>
      </div>
    </div>
  );
}